import { render, staticRenderFns } from "./AulasPraticasEnviadasDetalhadas.vue?vue&type=template&id=29a37f30"
import script from "./AulasPraticasEnviadasDetalhadas.vue?vue&type=script&lang=js"
export * from "./AulasPraticasEnviadasDetalhadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports